module.exports = __webpack_public_path__ + "static/media/card-delete.86f83c3b.svg";